<div class="custom-dialog">
    <div class="header">
        <span>Register</span>
        <span class="close" (click)="onClose()">x</span>
    </div>
    <div *ngIf="errorMessage" class="errorMessage">{{errorMessage}}</div>
  
    <mat-form-field [class.error]="showError && !hasValidEmailAddress">
        <mat-label>{{!hasValidEmailAddress && info.emailAddress && showError ? 'Invalid Email Address' : 'Email Address'}}</mat-label>
        <input matInput type="text" [(ngModel)]="info.emailAddress" autocomplete="off" cdkFocusInitial>    
    </mat-form-field>
    <mat-form-field [class.error]="showError && !info.firstName">
        <mat-label>First Name</mat-label>
        <input matInput type="text" [(ngModel)]="info.firstName" autocomplete="off">    
    </mat-form-field>
    <mat-form-field [class.error]="showError && !info.lastName">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" [(ngModel)]="info.lastName" autocomplete="off">    
    </mat-form-field>

    <mat-form-field>
        <mat-label>NAV Customer Number</mat-label>
        <input matInput type="text" [(ngModel)]="info.navCustomerNo" autocomplete="off">    
    </mat-form-field>
    <div class="message">
        <div>Password must contain the following:</div>
        <div [class]="hasLowerCaseLetters ? 'valid' : 'invalid'">A <b>lowercase</b> letter</div>
        <div [class]="hasUpperCaseLetters ? 'valid' : 'invalid'">A <b>capital (uppercase)</b> letter</div>
        <div [class]="hasNumber ? 'valid' : 'invalid'">A <b>number</b></div>
        <div [class]="hasSpecialCharacter ? 'valid' : 'invalid'">A <b>special character</b></div>
        <div [class]="hasMinimumCharacters ? 'valid' : 'invalid'">Minimum <b>8 characters</b></div>
      </div>
    <mat-form-field [class.error]="showError && !hasValidPassword">
        <mat-label>Password</mat-label>
        <input matInput type="text" [(ngModel)]="info.password" type="password" autocomplete="off">    
    </mat-form-field>
    <mat-form-field [class.error]="(showError && !hasValidPassword) || (info.password && info.confirmPassword && info.password !== info.confirmPassword)">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="text" [(ngModel)]="info.confirmPassword" type="password" autocomplete="off">    
    </mat-form-field>
    
    <div class="footer">
        <app-button (onClick)="onRegister()" label="Register" class="register-btn" className="primary-alt" [showSpinner]="showSpinner"></app-button>
    </div>
    </div>